import React, { useState } from "react";
import { Container, Row, Col, Button, Modal, ModalBody, ModalFooter, Card, CardBody, FormFeedback, Label, Input } from "reactstrap";
import { Link, useLocation } from "react-router-dom";
//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";

import Select from "react-select";

//i18n
import { withTranslation } from "react-i18next";
import moment from 'moment';

// Formik Validation
import * as Yup from "yup";
import { useFormik } from "formik";

import Snackbars from "../../Utils/Snackbars";
import useRequests from '../../Utils/useRequests';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';


const colourStyles = {
  menuList: styles => ({
    ...styles,
    background: '#ffffff',
  }),
  option: (styles, { isFocused, isSelected, isDisabled }) => ({
    ...styles,
    background: isFocused
      ? '#036B41'
      : isSelected
        ? isSelected
          ? "#036B41"
          : "#000"
        : undefined,
    zIndex: 1,
    color: isFocused
      ? '#fff'
      : isSelected
        ? isSelected
          ? "#F7F7FA"
          : "#000"
        : undefined,
    ':active': {
      ...styles[':active'],
      backgroundColor: !isDisabled
        ? isSelected
          ? "#fff"
          : "#036B41"
        : undefined,
    },
  }),
  menu: base => ({
    ...base,
    zIndex: 100,
  }),
}

const UserManagement = props => {
  const [modal_Delete_User, setmodal_Delete_User] = useState(false);
  function Delete_User() {
    setmodal_Delete_User(!modal_Delete_User);
    // removeBodyCss();
  }


  
  //meta title
  document.title = "User Management";
    const location = useLocation();
  const { getRequest, postRequest } = useRequests();


  const [AlertData, setAlertData] = React.useState({
        variant: '',
        message: '',
    });
    const resetAlertData = () => {
        setTimeout(() => {
            setAlertData((AlertData) => ({
                ...AlertData,
                variant: '',
                message: '',
            }));
        }, 5000);
    };
  
  const validation1 = useFormik({
    enableReinitialize: true,

    initialValues: {
      kyc_status: 'All',
      status: 'All',
      country: {label: 'All', value: 'All'},
    },
    validationSchema: Yup.object({
    }),
    onSubmit: (values) => {
      try {
        let submit1 = document.getElementById('submit1');
        submit1.disabled = true;
        submit1.textContent = 'Processing...';

        let filteredData = UsersData;
        if(values.kyc_status !== 'All') {
          filteredData = filteredData.filter(item => item.kyc_status === values.kyc_status);
        }
        if(values.status !== 'All') {
          filteredData = filteredData.filter(item => item.status === values.status);
        }
        if(values.country.value !== 'All') {
          filteredData = filteredData.filter(item => item.country === values.country.value);
        }

        if(filteredData.length > 0) {
          handleT1Body(filteredData);
        }
        else {
          let tempTBody = (<tr>
                          <td colSpan="9" className="text-center">No records found</td>
                        </tr>);

          setUsersTBody(tempTBody);
        }

        submit1.disabled = false;
        submit1.textContent = 'Search';
      } catch (error) {
        console.error("Error : ", error);
      }
    }
  });

  const [StandardModal2, setStandardModal2] = React.useState(false);
  const togStandardModal2 = async (elementData) => {
    validation2.setValues({
      ...validation2.values,
      g_id: elementData.g_id,
      status: elementData.gift_card_status,
    });
    setStandardModal2(true);
  }

  const validation2 = useFormik({
    enableReinitialize: true,
    initialValues: {
      g_id: '',
      status: '',
      eur_amount: '',
    },
    validationSchema: Yup.object({
      status: Yup.string()
        .test('not-pending', 'Please select status', value => value && value !== 'pending')
        .required('Please select status'),
      eur_amount: Yup.string().when('status', {
        is: val => val === 'approved',
        then: schema => schema.required('EUR Amount is required'),
        otherwise: schema => schema.notRequired(),
      }),
    }),
    onSubmit: async (values) => {
      try {
        let submit1 = document.getElementById('submit2');
        submit1.disabled = true;
        submit1.textContent = 'Processing...';

        const jsonpar = JSON.stringify({
          g_id: values.g_id,
          status: values.status,
          amount: values.status === 'approved' ? values.eur_amount : undefined
        });
        const res = await postRequest('update-gift-card-status', jsonpar);
        if (res && res.code === 200) {
          handleLoadGetUsers();
          setTimeout(() => {
            validation1.handleSubmit();
          }, 500);

          setAlertData((AlertData) => ({
            ...AlertData,
            variant: 'success',
            message: res.message,
          }));
        }
        else {
          setAlertData((AlertData) => ({
            ...AlertData,
            variant: 'error',
            message: res.message,
          }));
        }
        resetAlertData();
        validation2.values.eur_amount = '';
        submit1.disabled = false;
        submit1.textContent = 'Update';

        setStandardModal2(false);
      } catch (error) {
        console.error("Error : ", error);
      }
    }
  }); 

  const [isDisabled, setIsDisabled] = useState(false);
  const completeRegistrationMail = async (u_id) => {
      setIsDisabled(true); 
      
      const jsonpar = JSON.stringify({ u_id: u_id });
      const res = await postRequest('complete-registration-mail', jsonpar);

      if (res && res.code === 200) {  
          setAlertData((AlertData) => ({
              ...AlertData,
              variant: 'success',
              message: res.message,
          }));
      }
      else {
          setAlertData((AlertData) => ({
              ...AlertData,
              variant: 'error',
              message: res.message,
          }));
      }
      resetAlertData();
  }

  const [StandardModal, setStandardModal] = React.useState(false);
  const togStandardModal = async (elementData) => {
    validation.setValues({
      ...validation.values,
          u_id: elementData.u_id,
      });
      setStandardModal(true);
  }

      const validation = useFormik({
          enableReinitialize: true,
  
          initialValues: {
          u_id: '',
          welcome_bonus: '',
          referral_code: ''
          },
          validationSchema: Yup.object({
            welcome_bonus: Yup.number()
            .typeError('Welcome bonus must be a number')
            .required('Please enter welcome bonus')
            .positive('Welcome bonus must be greater than 0'),
            referral_code: Yup.string().required('Please enter referral code'),
          }),
          onSubmit: async (values) => {
          try {
              let submit1 = document.getElementById('submit1');
              submit1.disabled = true;
              submit1.textContent = 'Processing...';
  
              const jsonpar = JSON.stringify({
              u_id: values.u_id,
              collaborator_welcome_bonus: values.welcome_bonus,
              collaborator_referral_code: values.referral_code
              });
              const res = await postRequest('make-collaborator', jsonpar);
              if (res && res.code === 200) {  
                  setAlertData((AlertData) => ({
                  ...AlertData,
                  variant: 'success',
                  message: res.message,
                  }));
              }
              else {
              setAlertData((AlertData) => ({
                  ...AlertData,
                  variant: 'error',
                  message: res.message,
              }));
              }
              resetAlertData();
              
              submit1.disabled = false;
              submit1.textContent = 'Submit';
  
              setStandardModal(false);
              handleLoadGetUsers();
          } catch (error) {
              console.error("Error : ", error);
          }
          }
      });

  const [UsersData, setUsersData] = React.useState([]);
  const [UsersTBody, setUsersTBody] = React.useState('');
  const handleT1Body = async (tempData) => {
    const formatAddressPart = (value) => {
      return value && value.trim() !== "" ? value : "";
    };

    let tempTBody = tempData.map((element, index) => (
      <tr key={index}>
        <td>{element.g_id}</td>
        <td>{element.first_name}</td>
        <td>{element.last_name}</td>
        <td>{element.email}</td>
        <td>{element.gift_card}</td>
        <td><span className={"font-size-14 badge bg-secondary rounded-pill " + (element.gift_card_status === 'pending' ? 'badge-soft-warning' : element.gift_card_status === 'approved' ? 'badge-soft-success' : 'badge-soft-danger')}>{element.gift_card_status.charAt(0).toUpperCase() + element.gift_card_status.slice(1).toLowerCase()}</span></td>


        <td className="text-center">
            <Link title="Update Request" to="#" className="font-size-14 bg-primary edit-box" onClick={(e)=>togStandardModal2(element)}><i className="bx bx-cog"></i></Link>

        </td>
      </tr>
    ));

    setUsersTBody(tempTBody);
  }
  const handleLoadGetUsers = async () => {
    const res = await getRequest('get-gift-card');
    if (res && res.code === 200) {
      let originalText = res.data;

      setUsersData(originalText);

      handleT1Body(originalText);
    }
    else {
      let tempTBody = (<tr>
                        <td colSpan="9" className="text-center">No records found</td>
                      </tr>);

      setUsersTBody(tempTBody);

      setAlertData((AlertData) => ({
        ...AlertData,
        variant: 'error',
        message: res.message,
      }));
    }
    resetAlertData();
  }

  const [AllCountriesData, setAllCountriesData] = React.useState([]);
  const handleLoadGetAllCountries = async () => {
    const res = await getRequest('get-all-countries');
    if (res && res.code === 200) {
      let originalText = res.data;

      let tempArr = [{label: 'All', value: 'All'}];
      originalText.forEach (element => {
        let temp = {
            label: element.country_name,
            value: element.country_name,
        };
        tempArr.push(temp);
      });
      tempArr = [{
          options: tempArr
      }];
      setAllCountriesData(tempArr);
    }
    else {
      setAlertData((AlertData) => ({
        ...AlertData,
        variant: 'error',
        message: res.message,
      }));
    }
    resetAlertData();
  }
  React.useEffect(() => {
    handleLoadGetUsers();
    handleLoadGetAllCountries();

    if (typeof location.state !== 'undefined' && typeof location.state.message !== 'undefined') {
      setAlertData((AlertData) => ({
        ...AlertData,
        variant: location.state.status,
        message: location.state.message,
      }));
      resetAlertData();
        }
  }, []);


  return (
    <React.Fragment>
            {AlertData.message !== '' ? <Snackbars variant={AlertData.variant} message={AlertData.message} /> : ''}
      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumbs title={props.t("Tokenizedgreen")} breadcrumbItem={props.t("Gift Card Redemption Request")} />
          <Row>
            <Col lg="12">
              <Card>
                <CardBody>
                  <div className="table-rep-plugin">
  
                    <div className="table-responsive mb-0">
                      <table className="table table-hover table-highlight" style={{ minWidth: '1500px' }}>
                        <thead>
                          <tr>
                            <th style={{ width: '100px' }}>#</th>
                            <th style={{ width: '200px' }}>First Name</th>
                            <th style={{ width: '200px' }}>Last Name</th>
                            <th style={{ width: '200px' }}>Email ID</th>
                            <th style={{ width: '200px' }}>Gift Card Code</th>
                            <th style={{ width: '200px' }}>Status</th>
                            <th>Actions</th>
                          </tr>
                        </thead>
                        <tbody>
                          {UsersTBody}
                        </tbody>
                      </table>
                    </div>
                    <div className="infoIcon">

                      <div className="infoIconBox">
                        <i className="bx bx-cog"></i>
                        <p>Update Request</p>
                      </div>

                    </div>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>

        </Container>
      </div>

      <Modal isOpen={modal_Delete_User} toggle={() => { Delete_User(); }} backdrop={'static'} centered className="transation">
        <div>
          <div className="modal-header">
            <h5 className="modal-title mt-0">Delete User</h5>
            <button type="button" onClick={() => { setmodal_Delete_User(false); }} className="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <ModalBody>
            <p>Are you sure you wan't to delete this user?</p>
          </ModalBody>
          <ModalFooter>
            <Button type="button" color="primary" onClick={() => { setmodal_Delete_User(false); }} >Delete</Button>
            <Button type="button" color="light" onClick={() => { setmodal_Delete_User(false); }} >Cancel</Button>
          </ModalFooter>
        </div>
      </Modal>

      <Modal isOpen={StandardModal2} backdrop={'static'} centered className="transation">
        <div>
          <div className="modal-header">
            <h5 className="modal-title mt-0">Update Request</h5>
            <button type="button" onClick={(e)=>{setStandardModal2(false);}} className="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <ModalBody>
            {/* Info fields for Name, Email, Gift Card Code */}
            <div className="mb-3">
              <div><b>Name:</b> {(() => {
                const user = UsersData.find(u => u.g_id === validation2.values.g_id);
                return user ? `${user.first_name} ${user.last_name}` : '';
              })()}</div>
              <div><b>Email:</b> {(() => {
                const user = UsersData.find(u => u.g_id === validation2.values.g_id);
                return user ? user.email : '';
              })()}</div>
              <div><b>Gift Card Code:</b> {(() => {
                const user = UsersData.find(u => u.g_id === validation2.values.g_id);
                return user ? user.gift_card : '';
              })()}</div>
            </div>
            <div className="mb-3">
              <label className="form-label">Select Status :</label>
              <select className="form-select" name="status"
                value={validation2.values.status}
                onChange={e => {
                  validation2.setFieldValue('status', e.target.value, true);
                  validation2.setFieldTouched('status', true, true);
                  setTimeout(() => validation2.validateField('status'), 0);
                }}
                >
                <option value="pending">Pending</option>
                <option value="approved">Approved</option>
                <option value="rejected">Rejected</option>
              </select>
              {validation2.errors.status && validation2.touched.status && (
                <FormFeedback type="invalid" style={{ display: 'block' }}>{validation2.errors.status}</FormFeedback>
              )}
            </div>
            {validation2.values.status === 'approved' && (
              <div className="mb-3">
                <label className="form-label">EUR Amount :</label>
                <Input
                  type="number"
                  name="eur_amount"
                  value={validation2.values.eur_amount}
                  onChange={validation2.handleChange}
                  onBlur={validation2.handleBlur}
                  invalid={!!(validation2.touched.eur_amount && validation2.errors.eur_amount)}
                />
                {validation2.touched.eur_amount && validation2.errors.eur_amount ? (
                  <FormFeedback type="invalid">{validation2.errors.eur_amount}</FormFeedback>
                ) : null}
              </div>
            )}
          </ModalBody>
          <ModalFooter>
            <Button type="button" color="primary"
              id="submit2"
              onClick={(e) => {
                e.preventDefault();
                validation2.handleSubmit();
                return false;
              }}
            >Update</Button>
            <Button type="button" color="light" onClick={(e)=>setStandardModal2(false)} >Cancel</Button>
          </ModalFooter>
        </div>
      </Modal>

      <Modal isOpen={StandardModal} backdrop={'static'} centered className="transation">
        <div>
          <div className="modal-header">
            <h5 className="modal-title mt-0">Make Collaborator</h5>
            <button type="button" onClick={(e)=>setStandardModal(false)} className="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <ModalBody>
          <div className="mb-3">
                    <Label className="form-label">Welcome Bonus :</Label>
                    <Input
                      name="welcome_bonus" 
                      type="text" 
                      placeholder={'Enter Welcome Bonus'}
                      onChange={validation.handleChange}
                      onBlur={validation.handleBlur}
                      value={validation.values.welcome_bonus || ""}
                      invalid={
                        validation.touched.welcome_bonus && validation.errors.welcome_bonus ? true : false
                      }
                    />
                    {validation.touched.welcome_bonus && validation.errors.welcome_bonus ? (
                      <FormFeedback type="invalid">{validation.errors.welcome_bonus}</FormFeedback>
                    ) : null}
                  </div>

                  <div className="mb-3">
                    <Label className="form-label">Referral code  :</Label>
                    <Input
                      name="referral_code" 
                      type="text" 
                      placeholder={'Enter Referral code'}
                      onChange={validation.handleChange}
                      onBlur={validation.handleBlur}
                      value={validation.values.referral_code || ""}
                      invalid={
                        validation.touched.referral_code && validation.errors.referral_code ? true : false
                      }
                    />
                    {validation.touched.referral_code && validation.errors.referral_code ? (
                      <FormFeedback type="invalid">{validation.errors.referral_code}</FormFeedback>
                    ) : null}
                  </div>
          </ModalBody>
          <ModalFooter>
            <Button 
              id="submit1"
              onClick={(e) => {
                e.preventDefault();
                validation.handleSubmit();
                return false;
              }}
            type="button" color="primary" >Submit</Button>
            <Button type="button" color="light" onClick={(e)=>setStandardModal(false)} >Cancel</Button>
          </ModalFooter>
        </div>
      </Modal>

    </React.Fragment>
  );
};

export default withTranslation()(UserManagement);